
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mass-send",
      function () {
        return require("private-next-pages/mass-send.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mass-send"])
      });
    }
  